import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import { contact } from '../data/mockData';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Mock submission
    console.log('Form submitted:', formData);
    toast.success('Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.');
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <div>
      {/* Hero Section */}
      <section 
        style={{
          position: 'relative',
          height: '50vh',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          background: 'var(--bg-secondary)'
        }}
      >
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url(https://images.unsplash.com/photo-1532926381893-7542290edf1d)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.5)'
          }}
        />
        
        <div className="container" style={{ position: 'relative', zIndex: 2, maxWidth: '1400px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-large" style={{ color: 'var(--bg-primary)', marginBottom: '16px' }}>
            Contactez-nous
          </h1>
          <p className="body-large" style={{ color: 'var(--bg-primary)' }}>
            Nous sommes à votre écoute pour toute demande
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="grid-two-column" style={{ alignItems: 'flex-start' }}>
            {/* Formulaire de contact */}
            <div>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Envoyez-nous un message
              </h2>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <div>
                  <label htmlFor="name" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    Nom complet *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      fontFamily: 'Suisse Regular, sans-serif',
                      transition: 'border-color 0.2s ease'
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="email" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      fontFamily: 'Suisse Regular, sans-serif',
                      transition: 'border-color 0.2s ease'
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    Téléphone
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      fontFamily: 'Suisse Regular, sans-serif',
                      transition: 'border-color 0.2s ease'
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="message" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      fontFamily: 'Suisse Regular, sans-serif',
                      resize: 'vertical',
                      transition: 'border-color 0.2s ease'
                    }}
                  />
                </div>

                <button 
                  type="submit" 
                  className="btn-primary"
                  style={{ 
                    width: 'fit-content',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  Envoyer
                  <Send size={16} />
                </button>
              </form>
            </div>

            {/* Informations de contact */}
            <div style={{ position: 'sticky', top: '100px' }}>
              <div 
                style={{
                  padding: '40px',
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px'
                }}
              >
                <h3 className="heading-2" style={{ marginBottom: '32px', color: '#C9A961' }}>
                  Informations de contact
                </h3>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{ 
                      width: '48px', 
                      height: '48px', 
                      borderRadius: '0px',
                      border: '1px solid var(--border-medium)',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Phone size={20} color="#C9A961" />
                    </div>
                    <div>
                      <h4 className="body-regular" style={{ marginBottom: '8px', fontWeight: 700 }}>
                        Téléphone
                      </h4>
                      <a 
                        href={`tel:${contact.phone.replace(/\s/g, '')}`}
                        className="body-regular"
                        style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
                      >
                        {contact.phone}
                      </a>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{ 
                      width: '48px', 
                      height: '48px', 
                      borderRadius: '0px',
                      border: '1px solid var(--border-medium)',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Mail size={20} color="#C9A961" />
                    </div>
                    <div>
                      <h4 className="body-regular" style={{ marginBottom: '8px', fontWeight: 700 }}>
                        Email
                      </h4>
                      <a 
                        href={`mailto:${contact.email}`}
                        className="body-regular"
                        style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
                      >
                        {contact.email}
                      </a>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{ 
                      width: '48px', 
                      height: '48px', 
                      borderRadius: '0px',
                      border: '1px solid var(--border-medium)',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <MapPin size={20} color="#C9A961" />
                    </div>
                    <div>
                      <h4 className="body-regular" style={{ marginBottom: '8px', fontWeight: 700 }}>
                        Adresse
                      </h4>
                      <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                        {contact.address}<br />
                        {contact.city}
                      </p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{ 
                      width: '48px', 
                      height: '48px', 
                      borderRadius: '0px',
                      border: '1px solid var(--border-medium)',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Clock size={20} color="#C9A961" />
                    </div>
                    <div>
                      <h4 className="body-regular" style={{ marginBottom: '12px', fontWeight: 700 }}>
                        Horaires d'ouverture
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        {Object.entries(contact.hours).map(([day, hours]) => (
                          <div key={day} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span className="body-small" style={{ textTransform: 'capitalize', color: 'var(--text-secondary)' }}>
                              {day}
                            </span>
                            <span className="body-small" style={{ color: 'var(--text-secondary)', fontWeight: 700 }}>
                              {hours}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Boutons de réservation */}
              <div style={{ marginTop: '32px' }}>
                <h3 className="heading-3" style={{ marginBottom: '16px' }}>
                  Réserver en ligne
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <a 
                    href="https://www.planity.com/nina-care-institut-91360-villemoisson-sur-orge" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn-primary"
                    style={{ textAlign: 'center' }}
                  >
                    Planity
                  </a>
                  <a 
                    href="https://www.treatwell.fr/salon/nina-care-institut-1/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn-primary"
                    style={{ textAlign: 'center' }}
                  >
                    Treatwell
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section style={{ height: '400px', background: 'var(--bg-secondary)' }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2634.547!2d2.425!3d48.67!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e5dc0f0f0f0f0f%3A0x0!2s130%20Route%20de%20Corbeil%2C%2091360%20Villemoisson-sur-Orge!5e0!3m2!1sfr!2sfr!4v1234567890"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Localisation Nina Care Institut"
        />
      </section>
    </div>
  );
};

export default Contact;
